import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceCompanyDto extends EpimsBaseEntityDto {
  CorrespondenceCompanyName: string;
  SubscriptionUserId: string;  
  Version: number;
}

